export default "/dist/files/icone_vetements.e256fb0286052606db8082e1f485b8b9.svg";